import { Flex, Image } from '@chakra-ui/react'
import React from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const AccessDenied = () => {
    const orgId = useSelector((state) => state.user.orgId);
    const navigate = useNavigate();
    return (
        <Flex justify="center" align="center" mt={0.5}>
            <Image onClick={() => navigate(`/dashboard?orgId=${orgId}`)} src="https://community.progress.com/servlet/rtaImage?eid=ka74Q0000000CRz&feoid=00N4Q00000BuE44&refid=0EM4Q000001rw4m" />
        </Flex>
    )
}

export default AccessDenied
